import { render } from "./WithdrawalPassword.vue?vue&type=template&id=6288bd02&scoped=true"
import script from "./WithdrawalPassword.vue?vue&type=script&lang=js"
export * from "./WithdrawalPassword.vue?vue&type=script&lang=js"

import "./WithdrawalPassword.vue?vue&type=style&index=0&id=6288bd02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6288bd02"]])

export default __exports__